import React, { useEffect, useState } from "react";
import { Box, Flex, Spinner, Text, useToast } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import GButton from "components/ui/button/Button";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getTagsOfProduct } from "../services/addingTagsService";
import AddingTagsLevel from "./AddingTagsLevel";
import ProductPricesPerBranchesModal from "./modals/AddingTagsModal";
import { checkIdExists } from "utils/cheackAuth";
import CryptoJS from 'crypto-js';
import NotAuthorizedCompo from "components/ui/NotAuthorizedCompo/NotAuthorizedCompo";
import useDecryptedPrivilege from "hooks/useDecryptedPrivilege ";

const CustomPriceBranche = () => {

  const retrievedArray =useDecryptedPrivilege()
  const ManageMenu = checkIdExists(retrievedArray, 38);
  const ReadMenu = checkIdExists(retrievedArray, 37);
  
  const id = useParams();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [customTag, setCustomTag] = useState(false);

  const tagsOfProduct = useSelector((state) => state.addTags);

  useEffect(() => {
    dispatch(getTagsOfProduct(id.productId));
  }, [dispatch, id]);

  
  const toast2 = useToast({ position: "top", duration: 3000, status: "error" });


  if(customTag && ManageMenu===false){
    toast2({ description:  t("general.authorization")})
    setCustomTag(false)
  }

  return (
    <Box>
      <Flex
        alignItems="center"
        justifyContent="space-between"
        gap={2}
        flexWrap="wrap"
        mb={6}
      >
        <Text color="text" textTransform="capitalize">
          {t("pages.inventory.tags")}
        </Text>

        <GButton
          title={t("pages.inventory.add_tag")}
          bg="light"
          color="text"
          fontSize="14px"
          border="1px solid"
          borderColor="border"
          hover={{ bg: "light" }}
          onClick={() => setCustomTag(true)}
        />
      </Flex>

      {tagsOfProduct.isLoading ? (
        <Spinner />
      ) : tagsOfProduct.data?.length === 0 ? (
        <Flex
          p={4}
          bg="white"
          alignItems="center"
          justifyContent="center"
          color="text"
          textTransform="capitalize"
          boxShadow="0rem 0.3125rem 0.3125rem 0rem rgba(82, 63, 105, 0.05)"
          borderRadius={6}
        >
          {t("pages.branches.no_data")}
        </Flex>
      ) : tagsOfProduct.data?.length > 0 ? (
        <AddingTagsLevel
          data={tagsOfProduct.data}
        />
      ) : (
        <Flex
          p={4}
          bg="white"
          alignItems="center"
          justifyContent="center"
          color="text"
          textTransform="capitalize"
          boxShadow="0rem 0.3125rem 0.3125rem 0rem rgba(82, 63, 105, 0.05)"
          borderRadius={6}
        >
          {t("pages.branches.no_data")}
        </Flex>
      )}

      {customTag && (
        <ProductPricesPerBranchesModal
          onClose={() => setCustomTag(false)}
        />
      )}
    </Box>
  );
};

export default CustomPriceBranche;
